import { Card, DataTable, Group, Tag, Title, Icon } from "components/common";
import {
  useGetActivityListQuery,
  useUpdateActivityStatusMutation,
} from "./api";
import theme from "utils/themeVars";
import { ActionButtons } from "components/custom";
import styles from "./index.module.less";

const UserActivity = () => {
  const columns = [
    {
      title: "#",
      dataIndex: "key",
      className: "tableStartSpace",
      width: 80,
      align: "center",
    },
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Icon icon="FiFileText" size={14} />
          Description
        </div>
      ),
      dataIndex: "text",
      width: 350,
    },
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Icon icon="FiTag" size={14} />
          Type
        </div>
      ),
      dataIndex: "type",
    },
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Icon icon="FiCalendar" size={14} />
          Created At
        </div>
      ),
      dataIndex: "created_at",
    },
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Icon icon="FiActivity" size={14} />
          Status
        </div>
      ),
      dataIndex: "status",
      align: "center",
    },
    { 
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Icon icon="FiSettings" size={14} />
          Actions
        </div>
      ), 
      dataIndex: "actions", 
      width: 100,
      align: "center",
    },
  ];

  const {
    data: activity,
    isLoading: loading,
    error,
    refetch,
    isFetching,
  } = useGetActivityListQuery();
  const [changeActivityStatus, _] = useUpdateActivityStatusMutation();

  const getActionsList = (e) => {
    return [
      {
        key: "close_activity",
        icon: "IoMdClose",
        color: theme["error-color"],
        content: "Close Activity",
        title: "Close Activity",
        className: "pointer",
        onClick: () => {
          changeActivityStatus({
            activity_id: e?.activity_id,
            status: "Closed",
          });
        },
      },
    ];
  };

  const tableData = () => {
    return activity?.length
      ? activity?.map((e, index) => ({
          key: index + 1,
          ...e,
          created_at: (
            <div style={{ display: "flex", gap: "8px" }}>
              {new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(e?.created_at))}
            </div>
          ),
          status: (
            <Tag
              color={
                e.status == "Created"
                  ? theme["primary-color"]
                  : e?.status == "updated"
                  ? theme["primary-light"]
                  : theme["error-color"]
              }
              style={{ borderRadius: "40px" }}
            >
              {e.status}
            </Tag>
          ),
          actions: <ActionButtons list={getActionsList(e)} />,
        }))
      : [];
  };
  return (
    <div className={styles.activityContainer}>
      <div className={styles.activityHeader}>
        <div className={styles.headerContent}>
          <Icon icon="FiActivity" size={24} style={{ color: "#4b93ff" }} />
          <div>
            <Title level={2} style={{ margin: 0, color: "#1a1a1a" }}>
              User Activity
            </Title>
            <p style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>
              Track and manage your account activities
            </p>
          </div>
        </div>
        <div className={styles.activityStats}>
          <div className={styles.statItem}>
            <Icon icon="FiTrendingUp" size={16} style={{ color: "#10b981" }} />
            <span>Total: {activity?.length || 0}</span>
          </div>
        </div>
      </div>

      <Card className={styles.activityCard}>
        <DataTable
          pagination={{
            totalCount: activity?.pagination?.totalCount,
            pageOptions: [10, 25, 50],
          }}
          paginationOnBottom={true}
          onChangePage={(queryObj) => {}}
          columns={columns}
          data={tableData()}
          loading={loading}
          error={error}
          stickyOffset={0}
          onErrorRetry={refetch}
          skeletonLoading={isFetching}
        />
      </Card>
    </div>
  );
};

export default UserActivity;
